<template>
  <el-dialog
    :title="field(shopName) + '：配送时段'"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="70%"
  >
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
    >
      <el-table-column :label="$t('Timeframe')">
        <template slot-scope="scope"
          >{{ scope.row.StartTime }} ~ {{ scope.row.EndTime }}</template
        >
      </el-table-column>
      <el-table-column
        prop="SettleHour"
        label="提前结算（小时）"
        width="130"
      ></el-table-column>
      <el-table-column prop="Week" :label="$t('Week')">
        <template slot-scope="scope">
          <span v-for="item in scope.row.WeekIds" :key="item"
            >{{ weekList[item] }},</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="MaxNumber"
        :label="$t('MaxNumber')"
        width="130"
      ></el-table-column>
      <el-table-column prop="Enabled" :label="$t('Enabled')" width="70">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? $t("enabled") : $t("disable") }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('operation')" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="
              openTourDiyConfig(
                scope.row.StartTime,
                scope.row.Shop_Id,
                scope.row.Id
              )
            "
            >拼团</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="60%"
    >
      <el-form :model="editForm" label-width="150px" ref="editForm">
        <el-form-item
          label="提前结算（小时）"
          prop="SettleHour"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '提前结算（小时）',
          }"
        >
          <el-input-number
            v-model.number="editForm.SettleHour"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="99"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="星期">
          <el-select
            v-model="editForm.WeekIds"
            multiple
            placeholder="Select Week"
            style="width: 520px"
          >
            <el-option
              v-for="(value, key) in weekList"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('StartDateTime')"
          prop="StartTime"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('StartDateTime'),
          }"
        >
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            v-model="editForm.StartTime"
            :placeholder="$t('StartDateTime')"
          ></el-time-picker>
        </el-form-item>
        <el-form-item
          :label="$t('EndDateTime')"
          prop="EndTime"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('EndDateTime'),
          }"
        >
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            v-model="editForm.EndTime"
            :placeholder="$t('EndDateTime')"
          ></el-time-picker>
        </el-form-item>
        <el-form-item
          :label="$t('MaxNumber')"
          prop="MaxNumber"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('MaxNumber'),
          }"
        >
          <el-input
            v-model.number="editForm.MaxNumber"
            type="text"
            style="width: 195px"
          >
            <template slot="suffix">0为不限</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="60%"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm">
        <el-form-item
          label="提前结算（小时）"
          prop="SettleHour"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '提前结算（小时）',
          }"
        >
          <el-input-number
            v-model.number="addForm.SettleHour"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="99"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="星期">
          <el-select
            v-model="addForm.WeekIds"
            multiple
            placeholder="Select Week"
            style="width: 520px"
          >
            <el-option
              v-for="(value, key) in weekList"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('StartDateTime')"
          prop="StartTime"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('StartDateTime'),
          }"
        >
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            v-model="addForm.StartTime"
            :placeholder="$t('StartDateTime')"
          ></el-time-picker>
        </el-form-item>
        <el-form-item
          :label="$t('EndDateTime')"
          prop="EndTime"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('EndDateTime'),
          }"
        >
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            v-model="addForm.EndTime"
            :placeholder="$t('EndDateTime')"
          ></el-time-picker>
        </el-form-item>
        <el-form-item
          :label="$t('MaxNumber')"
          prop="MaxNumber"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('MaxNumber'),
          }"
        >
          <el-input
            v-model.number="addForm.MaxNumber"
            type="text"
            style="width: 195px"
          >
            <template slot="suffix">0为不限</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="批量添加"
      :visible.sync="addAllFormVisible"
      v-model="addAllFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="60%"
    >
      <el-form :model="addAllForm" label-width="150px" ref="addAllForm">
        <el-form-item
          label="提前结算（小时）"
          prop="SettleHour"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '提前结算（小时）',
          }"
        >
          <el-input-number
            v-model.number="addAllForm.SettleHour"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="99"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="星期"
          prop="WeekIds"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '星期',
          }"
        >
          <el-select
            v-model="addAllForm.WeekIds"
            multiple
            placeholder="Select Week"
            style="width: 520px"
          >
            <el-option
              v-for="(value, key) in weekList"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="时段间隔"
          prop="Interval"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '间隔（分钟）',
          }"
        >
          <el-input-number
            v-model.number="addAllForm.Interval"
            :precision="0"
            :step="1"
            :min="10"
            :max="60"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="配送间隔"
          prop="DawInterval"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '间隔（分钟）',
          }"
        >
          <el-input-number
            v-model.number="addAllForm.DawInterval"
            :precision="0"
            :step="1"
            :min="10"
            :max="90"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$t('StartDateTime')"
          prop="StartH"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('StartDateTime'),
          }"
        >
          <el-select v-model="addAllForm.StartH" placeholder="请选择">
            <el-option
              v-for="item in hourOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('EndDateTime')"
          prop="EndH"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('EndDateTime'),
          }"
        >
          <el-select v-model="addAllForm.EndH" placeholder="请选择">
            <el-option
              v-for="item in hourOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="addAllForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addAllFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addAllSubmit"
          :loading="addAllLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--新增-->
    <el-dialog
      title="批量添加拼团配置"
      :visible.sync="addConfigFormVisible"
      v-model="addConfigFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="addConfigForm"
        label-width="150px"
        ref="addConfigForm"
        size="small"
      >
        <el-form-item
          label="选择时段"
          prop="ShippingTime_Id"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('选择时段'),
          }"
        >
          <el-select
            v-model="addConfigForm.ShippingTime_Id"
            multiple
            clearable
            collapse-tags
            placeholder="请选择时段"
          >
            <el-option
              v-for="item in list"
              :key="item.Id"
              :label="item.StartTime"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$t('Name')"
          prop="Name"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Name'),
          }"
        >
          <el-input
            v-model="addConfigForm.Name"
            maxlength="13"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="人数"
          prop="Number"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '人数',
          }"
        >
          <el-input
            type="number"
            v-model.number="addConfigForm.Number"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="减免金额"
          prop="Derate"
          :rules="{ required: true, message: $t('pleaseEnter') + '减免金额' }"
        >
          <el-input-number
            v-model.number="addConfigForm.Derate"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('Enabled')">
          <el-switch v-model="addConfigForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addConfigFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addConfigSubmit"
          :loading="addConfigLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <TourDiyConfig ref="tourDiyConfigDialog"></TourDiyConfig>
    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import TourDiyConfig from "./TourDiyConfig";
import {
  getShippingTimeList,
  removeShippingTime,
  editShippingTime,
  addShippingTime,
  addAllShippingTime,
  addAllTourDiyConfig,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  components: {
    TourDiyConfig,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      weekList: {
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
        0: "星期日",
      },
      dialogVisible: false,
      shopId: 0,
      shopName: "",
      buttonList: [],
      list: [],
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      addAllFormVisible: false, //新增界面是否显示
      addAllLoading: false,
      //新增界面数据
      addAllForm: {},
      hourOptions: [],
      addConfigFormVisible: false, //新增界面是否显示
      addConfigLoading: false,
      //新增界面数据
      addConfigForm: {},
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    openTourDiyConfig(name, sid, id) {
      this.$refs.tourDiyConfigDialog.loadData(name, sid, id);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    handleAllAddConfig() {
      this.addConfigFormVisible = true;
      this.addConfigForm = {
        ShippingTime_Id: [],
        Name: "",
        Number: 2,
        Derate: 0,
        Shop_Id: this.shopId,
        Enabled: true,
      };
    },
    //批量新增配置
    addConfigSubmit: function () {
      let _this = this;
      this.$refs.addConfigForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addConfigLoading = true;
              let para = Object.assign({}, this.addConfigForm);
              addAllTourDiyConfig(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addConfigLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addConfigLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addConfigForm"].resetFields();
                  this.addConfigFormVisible = false;
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //显示批量新增界面
    handleAllAdd() {
      this.addAllFormVisible = true;

      this.addAllForm = {
        Shop_Id: this.shopId,
        SettleHour: 1,
        StartH: 9,
        EndH: 23,
        Interval: 30,
        DawInterval: 90,
        Enabled: true,
      };
    },
    //批量新增
    addAllSubmit: function () {
      let _this = this;
      console.log(this.addAllForm);
      this.$refs.addAllForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addAllLoading = true;
              let para = Object.assign({}, this.addAllForm);
              addAllShippingTime(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addAllLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addAllLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addAllForm"].resetFields();
                  this.addAllFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //获取列表
    getList() {
      let para = {
        shopId: this.shopId,
        isEnabled: false,
      };
      this.listLoading = true;
      getShippingTimeList(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });
        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShippingTime(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign(
        { CalDay: 0, CalTime: "" },
        this.clone(row)
      );
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Shop_Id: this.shopId,
        CalDay: 0,
        CalTime: "",
        SettleHour: 1,
        StartTime: "",
        EndTime: "",
        Enabled: true,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editShippingTime(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;
              addShippingTime(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    loadData(sname, sid) {
      this.shopName = sname;
      this.shopId = sid;
      this.getList();
      this.dialogVisible = true;
      for (var i = 9; i < 23; i++) {
        this.hourOptions.push({ value: i, label: i });
      }
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList("/ShopConfig/ShippingTime", routers);
    },
  },
};
</script>

<style scoped>
</style>
